export enum RUMChartTab {
  PAGE_LOAD_TIME = "PAGE_LOAD_TIME",
  AJAX_LOAD_TIME = "AJAX_LOAD_TIME",
  ERRORS = "ERRORS",
  BOUNCE_RATE = "BOUNCE_RATE",
}

export const RUMChartTabLabels: Record<RUMChartTab, string> = {
  [RUMChartTab.PAGE_LOAD_TIME]: "Page Load Time",
  [RUMChartTab.AJAX_LOAD_TIME]: "Ajax Load Time",
  [RUMChartTab.ERRORS]: "Errors",
  [RUMChartTab.BOUNCE_RATE]: "Bounce Rate",
};

export const RUMChartTabParams: Record<RUMChartTab, string> = {
  [RUMChartTab.PAGE_LOAD_TIME]: "pageLoad",
  [RUMChartTab.AJAX_LOAD_TIME]: "ajaxLoad",
  [RUMChartTab.ERRORS]: "errors",
  [RUMChartTab.BOUNCE_RATE]: "bounceRate",
};
